import classNames from "classnames";
import { FC } from "react";
import { useDarkModeContext } from "../../src/context/DarkModeContext";
import styles from "./PageHeader.module.scss";
import { PageHeaderProps } from "./type";

const PageHeader: FC<PageHeaderProps> = ({ title }) => {
  const { darkMode } = useDarkModeContext();

  return (
    <div className={classNames(styles.element, "container", darkMode && styles.darkMode)}>
      <h4>{title}</h4>
    </div>
  );
};

export default PageHeader;
